import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

type Props = {
  values: string[]
  onChange: (values: string[]) => void
  options: string[]
}

export function ChartHourSeriesSelect({
  values,
  onChange,
  options,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <FormControl variant="outlined">
      <InputLabel>{t('charts.hourSeriesSelectLabel')}</InputLabel>
      <Select
        label={t('charts.hourSeriesSelectLabel')}
        value={values}
        onChange={(event) => onChange(event.target.value as string[])}
        multiple
        displayEmpty
        renderValue={(selected) =>
          t('common.showing', {
            value: (selected as string[]).length ?? 0,
          })
        }
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
